/**
 * @version 1.0
 * @author xieyq
 * @createTime 2021/11/9
 * @updateTime 2021/11/9
 * @decription
 * @namespace 【】
 */
import MyTitle from '@/components/common/myTitle'
import PreviewBasic from '../previewReconsider/previewBasic'; //复议基本信息
import PreviewSQR from '../previewReconsider/previewSQR'; //复议申请人
import PreviewDLR from '../previewReconsider/previewDLR';//复议代理人
import PreviewSCCL from '../previewReconsider/previewSCCL';//复议材料
import PreviewFyInfo from '../previewReconsider/previewFyInfo';
// 复议中请求js混入
import request from "@/views/applyReconsider/mixins/request";
export default {
    mixins: [request],
    data() {
        return {
            // 复议id
            fyid: this.$route.query.fyid,
            // 基础数据
            basicData: null,
            // 申请人数据列表
            sqrDataList: [],
            // 审核信息
            shxxData: null,
            // 上传材料数据
            scclData: {
                //申请书
                sqsFiles: [],
                // 立案受理通知书材料
                lasltzsFiles: [],
                //身份证明
                sfzmFiles: [],
                //证据类
                zjFiles: [],
                // 保全裁定书材料
                bqCdsFiles:[],
                // 其他材料文件
                qtFiles: []
            }
        }
    },
    // 依赖
    provide() {
        return {
            // 复议id
            fyid: this.fyid
        }
    },
    components: {
        MyTitle,
        PreviewBasic,
        PreviewSQR,
        PreviewDLR,
        PreviewSCCL,
        PreviewFyInfo
    },
    // 创建完成
    created() {
        // 初始化方法
        this.init();
    },
    methods: {
        /**
         * 初始化方法
         * */
        init() {
            // 获取基础数据
            this.getBasicData();
            // 获取申请人列表
            this.getSqrList();
            this.getDlrList();
            // 获取审核信息
            this.getShxx();
        },

        /**
         * 获取基础数据
         * */
        getBasicData() {
            // 请求基础数据并赋值
            this.requestBasic(this.fyid).then(data => {
                this.basicData = data;
            })
        },

        /**
         * 获取申请人列表
         * */
        getSqrList() {
            // 请求申请人数据
            this.requestSqrData(this.fyid).then(sqrDataList => {
                this.sqrDataList = sqrDataList;
            })
        },

        getDlrList() {
            // 请求申请人数据
            this.requestDlrData(this.fyid).then(dlrDataList => {
                this.transformData = this.getTransformData(dlrDataList);
            });
        },

        /**
         * 获取审核信息
         * */
        getShxx() {
            this.$axios.get('ssbq/api/fy/fycdxx?fyid=' + this.fyid).then(res => {
                // 赋值审核信息数据
                this.shxxData = res.data;
            });
        },

        /**
         * 获取上传材料列表
         * */
        getCcxsList() {
            this.$axios.get('ssbq/api/fy/fysccls?fyid=' + this.fyid).then(res => {
                // 上传材料数据
                const _scclData = {
                    sqsFiles: res.data.sqs,
                    qszFiles: res.data.qsz,
                    lasltzsFiles: res.data.lasltzs,
                    sfzmFiles: res.data.sfzml,
                    zjFiles: res.data.zjl,
                    qtFiles: res.data.qt
                }
                this.scclData = _scclData;
            })
        }
    },
    mounted() {
    }
}
